/* tslint:disable */
/* eslint-disable */

/**
 * 0 = CompanyLogo
 * 
 * 1 = EmailLogo
 * 
 * 2 = LoginLogo
 * 
 * 3 = CoverLogo
 * 
 * 4 = CoverBackground
 */
export enum AppThemeImageType {
  CompanyLogo = 0,
  EmailLogo = 1,
  LoginLogo = 2,
  CoverLogo = 3,
  CoverBackground = 4
}
